export const HOME_PAGE = "/";
export const LOGIN_PAGE = "/login";
export const SIGNUP_PAGE = "/signup";
export const FORGOT_PASSWORD_PAGE = "/forgot-password";
export const TRIAL_PAGE = "/trial";
export const TRIAL_SIGNUP_PAGE = "/trial-signup";
export const TRIAL_SIGNUP_ENTROPY_PAGE = "/trial-signup-entropy";
export const SET_PASSWORD_PAGE = "/set-password";
export const MFA_CHALLENGE_PAGE = "/mfa-challenge";
export const MFA_SETUP_PAGE = "/mfa-setup";
export const MARKETPLACE_REDIRECT_PAGE = "/marketplace/redirect";
export const DASHBOARD_PAGE = "/dashboard";
export const API_KEYS_PAGE = "/api-keys";
export const CLUSTERS_PAGE = "/clusters";
export const CONTRACTS_PAGE = "/contracts";
export const USAGE_PAGE = "/usage";
export const UTILIZATION_DEEP_DIVE_PAGE = "/utilization";
export const INVOICES_PAGE = "/invoices";
export const AUDIT_LOGS_PAGE = "/audit-logs";
export const CHANGELOGS_PAGE = "/changelogs";
export const ORGANIZATION_PAGE = "/organization";
export const CONTACT_PAGE = "/contact";
export const POSTS_PAGE = "/posts";
export const POST_PAGE = "/posts/:id";
